const environment = process.env.NODE_ENV || 'development';
const port = parseInt(process.env.PORT) || 3333;

const config = Object.freeze({
  ENVIRONMENT: environment,
  IS_PRODUCTION: environment === 'production',
  IS_STAGING: environment === 'staging',
  IS_DEVELOPMENT: environment === 'development',
  IS_TEST: environment === 'test',
  PORT: port,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REGION: process.env.REACT_APP_REGION,
  APPSYNC_BASE_URL: process.env.REACT_APP_APPSYNC_BASE_URL,
  WS_BASE_URL: process.env.REACT_APP_WS_BASE_URL,
  VOICE_STREAM_API: process.env.REACT_APP_VOICE_STREAM_API,
  AUTH_ACTION_LOGIN_URL: process.env.REACT_APP_AUTH_ACTION_LOGIN_URL,
  AUTH_CALLBACK_URL: process.env.REACT_APP_AUTH_CALLBACK_URL,
  APP_NAME: 'BC',
});

export default config;